import React from 'react';
import { View, Text, Image, ViewStyle, TextStyle } from 'react-native';
import { useImageSecurity } from '@common/components/ImageSecurity';

interface LogoProps {
  isCollapsed: boolean;
  textColor: string;
  logoImage?: string;
  logoText?: string;
  logoWidth?: number;
  logoHeight?: number;
  fontFamily?: string;
}

export const Logo: React.FC<LogoProps> = ({
  isCollapsed,
  textColor,
  logoImage,
  logoText = 'LOGO',
  logoWidth = 32,
  logoHeight = 32,
  fontFamily,
}) => {
  const { imageUrl: secureLogoImage } = useImageSecurity(logoImage || '');
  const containerStyle: ViewStyle = {
    alignItems: isCollapsed ? 'center' : 'flex-start',
    justifyContent: 'center',
    paddingVertical: isCollapsed ? 16 : 0,
    paddingHorizontal: isCollapsed ? 8 : 0,
    width: isCollapsed ? undefined : '100%',
  };

  const logoImageStyle = {
    width: isCollapsed ? 32 : '100%',
    height: isCollapsed ? 32 : logoHeight,
    resizeMode: 'contain' as const,
    maxWidth: isCollapsed ? 32 : logoWidth,
  };

  const logoTextStyle: TextStyle = {
    color: textColor,
    fontSize: isCollapsed ? 12 : 20,
    fontFamily: fontFamily,
    fontWeight: 'bold',
    textAlign: isCollapsed ? 'center' : 'left',
  };

  return (
    <View style={containerStyle}>
      {logoImage && logoImage.length ? (
        <Image source={{ uri: secureLogoImage }} style={logoImageStyle} />
      ) : (
        <Text style={logoTextStyle}>
          {isCollapsed ? logoText.charAt(0) : logoText || 'LOGO'}
        </Text>
      )}
    </View>
  );
};
